import Vue from 'vue'

export const events = {
  STYLE_EDIT: 'STYLE_EDIT',
  COLONNE_ADDED: 'COLONNE_ADDED',
  SELECT_PROJECT: 'SELECT_PROJECT',
  SELECT_ESPACES: 'SELECT_ESPACES',
  COPY_TABLEAU: 'COPY_TABLEAU',
  DELETE_TEMPLATE: 'DELETE_TEMPLATE',
  RESET_FILTER: 'RESET_FILTER',
  COPY_CELL: 'COPY_CELL',
  PASTE_CELL: 'PASTE_CELL',
  SCHEMA_ACTION: 'SCHEMA_ACTION',
  DELETE_FICHE: 'DELETE_FICHE',
  STROKE_SIZE: 'STROKE_SIZE',
  STROKE_COLOR: 'STROKE_COLOR',
  SHAPE_FILL: 'SHAPE_FILL',
  SHEMA_EXPORT: 'SHEMA_EXPORT',
  SHEMA_SAVE: 'SHEMA_SAVE',
  SAVE_CONFIRM: 'SAVE_CONFIRM',
  ON_DESCRIPTION_OPEN: 'ON_DESCRIPTION_OPEN',
  HAS_MODIFICATION: 'HAS_MODIFICATION',
  // -- article
  ON_ADD_ARTICLE: 'ON_ADD_ARTICLE',
  ON_SAVE_ARTICLE: 'ON_SAVE_ARTICLE',
  ON_DELETE_ARTICLE: 'ON_DELETE_ARTICLE',
  ON_MASKING_ARTICLE: 'ON_MASKING_ARTICLE',
  ON_FOCUS_EDITOR: 'ON_FOCUS_EDITOR',
  ON_SAVE_ARTICLE_BIBLIO: 'ON_SAVE_ARTICLE_BIBLIO',
  ON_DELETE_ARTICLE_BIBLIO: 'ON_DELETE_ARTICLE_BIBLIO',
  ON_COLLAPSE_ALL_ARTICLES: 'ON_COLLAPSE_ALL_ARTICLES',
  REFRESH_NOTIFICATION: 'REFRESH_NOTIFICATION'
}

export const EventBus = new Vue()



// WEBPACK FOOTER //
// ./src/eventBus.js